module.exports = __webpack_public_path__ + "static/the-innovators-dilemma-e81efb8db99e78f213a6970767549c8a.jpg";